<template>
  <v-menu v-model="expanded" location="bottom center" eager>
    <template #activator="{ props }">
      <a v-bind="props" class="plain centered">
        <slot name="activator" />
        <NavBarRotatingIcon :expanded />
      </a>
    </template>

    <NavBarSelectListContainer>
      <slot />
    </NavBarSelectListContainer>
  </v-menu>
</template>

<script setup lang="ts">
const expanded = ref(false);
</script>